export default __webpack_public_path__ + "static/media/ELEMENTOS_04.c3f51fb6.png";